import ErrorBoundary from "../../../ErrorBoundary";

export default function Footer() {
  return (
    <ErrorBoundary>
      <div className="bg-indigo-950 text-gray-100 py-1 fixed bottom-0 left-0 right-0 w-full z-10">
        <p className="text-end w-full pr-8">
          Copyright &copy; 2A Soft Solutions 2024
        </p>
      </div>
    </ErrorBoundary>
  );
}
